import { gql } from '../../../../../../hooks'

export const GET_FILE_PARSED = gql`
  query getFileParsed($text: String!, $file: String!) {
    t5ResultsByParsedFile(text: $text, file: $file) {
    }
  }
`
